import {
  readAdminPasswordStatus,
  readCurrentAdminRoleConfig,
  resolveAdminRoleConfig
} from "./admin-login";

const ROUTE_ROLE_TO_ADMIN_ROLE = {
  platform: "platform_admin",
  supplier: "tenant_admin",
  school: "school_admin"
};

function getStorage(storage) {
  if (storage) {
    return storage;
  }

  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage;
  }

  return null;
}

function resolveRouteRole(to) {
  if (to?.meta?.role) {
    return to.meta.role;
  }

  const path = String(to?.path || "");
  if (path.startsWith("/platform")) {
    return "platform";
  }
  if (path.startsWith("/supplier")) {
    return "supplier";
  }
  if (path.startsWith("/school")) {
    return "school";
  }
  return "";
}

function findStoredRoleConfig(storage) {
  const targetStorage = getStorage(storage);
  return readCurrentAdminRoleConfig(targetStorage);
}

export function resolveLoginNavigation(to, storage) {
  const targetStorage = getStorage(storage);
  const routeRole = resolveRouteRole(to);
  const fullPath = to?.fullPath || to?.path || "/";
  const storedRoleConfig = findStoredRoleConfig(targetStorage);
  const passwordStatus = readAdminPasswordStatus(targetStorage);
  const requiresPasswordSetup = Boolean(storedRoleConfig && passwordStatus.passwordSet === false);

  if (to?.path === "/login/password-setup") {
    if (!storedRoleConfig) {
      return {
        allow: false,
        redirect: "/login",
        role: ""
      };
    }

    if (passwordStatus.passwordSet === true) {
      return {
        allow: false,
        redirect: storedRoleConfig.homePath,
        role: storedRoleConfig.routeRole
      };
    }

    return {
      allow: true,
      redirect: "",
      role: storedRoleConfig.routeRole
    };
  }

  if (to?.path === "/login") {
    if (storedRoleConfig) {
      return {
        allow: false,
        redirect: requiresPasswordSetup
          ? `/login/password-setup?redirect=${encodeURIComponent(fullPath)}`
          : storedRoleConfig.homePath,
        role: storedRoleConfig.routeRole
      };
    }

    return {
      allow: true,
      redirect: "",
      role: ""
    };
  }

  if (!routeRole) {
    return {
      allow: true,
      redirect: "",
      role: ""
    };
  }

  const adminRole = ROUTE_ROLE_TO_ADMIN_ROLE[routeRole];
  const roleConfig = resolveAdminRoleConfig(adminRole);
  const token = roleConfig ? targetStorage?.getItem(roleConfig.tokenKey) : "";

  if (token) {
    if (requiresPasswordSetup) {
      return {
        allow: false,
        redirect: `/login/password-setup?redirect=${encodeURIComponent(fullPath)}`,
        role: roleConfig?.routeRole || ""
      };
    }

    return {
      allow: true,
      redirect: "",
      role: routeRole
    };
  }

  return {
    allow: false,
    redirect: `/login?redirect=${encodeURIComponent(fullPath)}`,
    role: routeRole
  };
}
